import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { login, msLogin } from "../../Store/Action/AuthAction";
import { image_login } from "../../Images";
import { useSelector } from "react-redux";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest, graphConfig } from "../../authConfig";
import { ms_logo } from "../../Images";

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const darkMode = useSelector((state) => state.theme.darkMode);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pswState, setPswState] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onPasswordStateChange = () => {
    setPswState(!pswState);
  };

  const onSubmit = (data) => {
    dispatch(
      login(navigate, data, ({ response }) => {
        if (response.data && response.data.message) {
          setErrorMessage(response.data.message);
        }
      })
    );

    <Navigate to="/home" replace={true} />;
  };

  const buttonMicrosoftCLick = () => {
    instance.loginRedirect(loginRequest).catch((err) => {
      console.log("Error", err);
    });
  };

  useEffect(() => {
    const msalaccountkeys = sessionStorage.getItem("msal.account.keys");

    if (isAuthenticated && msalaccountkeys) {
      instance
        .acquireTokenSilent({ ...loginRequest, account: accounts[0] })
        .then((res) => {
          const { accessToken } = res;
          dispatch(
            msLogin(navigate, { accessToken }, ({ response }) => {
              if (response.data && response.data.message) {
                setErrorMessage(response.data.message);
              }
            })
          );

          <Navigate to="/home" replace={true} />;
        });
    }
  }, [isAuthenticated]);

  return (
    <div className="login-container" style={{ height: "100vh" }}>
      <div
        className="bg-login d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: "#DDD",
          backgroundImage: `url(${image_login})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          opacity: 0.75,
        }}
      >
        <div className="col-md-6 col-sm-12"></div>
      </div>
      <div className="login-form" style={{}}>
        <div
          className="d-flex"
          style={{
            height: "100%",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row" style={{ width: "100%" }}>
              <div className="col-1"></div>
              <div className="col-10">
                <div className="form-group">
                  <h1
                    className="fade-in"
                    style={
                      darkMode
                        ? { color: "#f39c12", fontWeight: "800" }
                        : { color: "#000", fontWeight: "800" }
                    }
                  >
                    Login
                  </h1>
                  {/*<h4 style={
                    darkMode
                      ? { color: '#f39c12', fontSize: 18, fontWeight: 400, marginBottom: 20 }
                      : { color: '#777', fontSize: 18, fontWeight: 400, marginBottom: 20 }
                  }>Product Master Catalog</h4>*/}
                </div>
                <div
                  className="form-group fade-in"
                  style={{ marginBottom: "1.5rem", marginTop: "1.5rem" }}
                >
                  <label>Email or Username</label>
                  <div style={{ border: "solid 1px #ccc", borderRadius: 4 }}>
                    <input
                      {...register("username", {
                        required: { value: true, message: "Email is required" },
                      })}
                      className="inputLogin"
                    />
                  </div>
                  {errors.username && (
                    <span className="text-danger">
                      {errors.username.message}
                    </span>
                  )}
                </div>
                <div
                  className="form-group fade-in"
                  style={{ marginBottom: "3rem" }}
                >
                  <label>Password</label>
                  <div
                    style={{
                      border: "solid 1px #ccc",
                      borderRadius: 4,
                      display: "flex",
                    }}
                  >
                    <input
                      className="inputLogin"
                      type={pswState ? "text" : "password"}
                      {...register("password", {
                        required: {
                          value: true,
                          message: "Password is required",
                        },
                      })}
                    />
                    <a
                      onClick={onPasswordStateChange}
                      className="btn btn-outline"
                    >
                      <i
                        style={
                          darkMode ? { color: "#f39c12" } : { color: "#000" }
                        }
                        className={pswState ? "fa fa-eye" : "fa fa-eye-slash"}
                      />
                    </a>
                  </div>
                  {errors.password && (
                    <span className="text-danger">
                      {errors.password.message}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  {errorMessage && (
                    <span className="text-danger">{errorMessage}</span>
                  )}
                </div>
                <div
                  className="form-group fade-in"
                  style={{ marginBottom: "1.5rem", marginTop: "2.5rem" }}
                >
                  <div style={{ marginTop: 40 }}>
                    <button
                      type="submit"
                      className="btn btn-block btn-dark btn-lg"
                    >
                      <i className="fa fa-lock" /> Sign In
                    </button>
                  </div>
                </div>
                <div className="form-group fade-in">
                  <div
                    style={{
                      border: "solid 1px #ccc",
                      borderRadius: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      padding: 10,
                    }}
                    onClick={buttonMicrosoftCLick}
                  >
                    <img
                      src={ms_logo}
                      style={{ width: 20, height: 20, marginRight: 10 }}
                      alt=""
                    />
                    Sign In with Microsoft
                  </div>
                </div>
              </div>
              <div className="col-1"></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
